<template>
    <div class="top-box">
        <div class="top">
            <div class="center clearfix">
                <h1 class="logo">
                    <a :href="'#/'" ><img :src="logo" alt="位讯科技"></a>
                </h1>
                <nav class="fr">
                    <ul class="nav-box clearfix">
                        <li class="nav-li fl">
                            <a class="nav-a" :class="{active:selected=='index'}" :href="'#/'" >首页</a>
                        </li>
                        <li class="nav-li fl business" @click="navTuer">
                            <div class="nav"  :style="'height:'+NavHeight+'px'">
                                <div class="nav-opt" ><a   :href="'#/cooperation'" >导游管理系统</a></div>
                                <!-- <div class="nav-opt" ><a   :href="'#/withgroup'" >跟团购系统</a></div> -->
                                <div class="nav-opt" ><a   :href="'#/withgroup'" >趣旅淘系统</a></div>
                                <div class="nav-opt" ><a   :href="'#/rescue'" >应急救援系统</a></div>
                            </div>
                            <a class="nav-a" :class="{active:selected=='cooperation'}"  >产品业务</a>
                        </li>
                        <!-- <li class="nav-li fl">
                            <a class="nav-a" :class="{active:selected=='league'}" :href="'#/league'" >关于我们</a>
                        </li> -->
                        <li class="nav-li fl ">
                            <a class="nav-a" :class="{active:selected=='league'}" :href="'#/league'" >申请试用<span class="bg-obj">申请试用</span></a>
                        </li>
                        <!-- <li class="nav-li fl">
                            <a class="nav-a" :class="{active:selected=='download'}" :href="'#/download'" >下载APP</a>
                            <router-link :to="{path: '/download'}" class="nav-a" :class="{active:selected=='download'}">下载APP</router-link>
                        </li> -->
                    </ul>
                </nav>
                <!-- <p class="phone fr">020-31125397</p> -->
            </div>
        </div>
        <div class="topPlaceholder"></div>
    </div>
</template>
<script>
  import global_ from './../../store/global'
export default {
    name: 'top',
    data () {
        return {
            logo:global_.imgUrl+'logo.png',
            NavHeight:0,
            flag:true,
        }

    },
    methods: {
        navTuer:function(){

         if(this.flag){
            this.NavHeight=120
         }else{
             this.NavHeight=0
         }
            this.flag=!this.flag

        }
    },
    props:['selected'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .top{
        position: fixed;
        z-index: 10;
        width: 100%;
        // min-width:1200px;
        min-width: 500px;
        height: 70px;
        top: 0;
        left: 0;
        background-color: #fff;
        border-bottom: 1px solid #09ba79;

        .logo{
            float: left;
            margin-top: 16px;
            margin-right: 50px;
            img{
                // width: 80%;
            }
        }
        .nav{

            position: absolute;
            top: 72px;
            width: 100%;
            height: 0px;
            overflow: hidden;
            z-index: 99;
            transition: all .3s;
            border-radius: 2px;
            background-color: #e6f8f1;
            // display: none;
            .nav-opt{
                width: 100%;
                height:40px;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
            }
            .nav-opt:hover{
                color: #fff;
                background-color: #58ba79;
            }

        }
        .nav-li{
            position: relative;
                        z-index: 999;
        }
        .nav-a{
            display: block;
            height: 70px;
            padding: 0 20px;
            font-size: 16px;
            color: #333;
            line-height: 70px;

            &.active{
                color: #09ba79;
                // background-color: #09ba79;
                // border-bottom:2px solid #09ba79;
            }
            &:hover{
                // color: #fff;
                // background-color: #ff8c00;
                border-bottom:2px solid #09ba79;
            }

        }
        .phone{
            font-size: 18px;
            color: #333;
            padding-left: 44px;
            background: url('../../assets/images/phone-icon.png') left center no-repeat;
            height: 90px;
            line-height: 90px;
        }
        // .business:hover .nav{
        //     height: 120px;
        // }
    }
    .topPlaceholder{
        width: 100%;
        height: 70px;
    }
    .bg-obj{
        position: absolute;
        top: 20px;
        right: 12px;
        display: inline-block;
        color: #fff;
        text-align: center;
        width: 80px;
        height: 30px;
        line-height: 30px;
        background-color: #09ba79;
        border-radius: 6px;
    }
    .opt:hover {
        // background-color: #e6f8f1;
        background-color: blue;
    }

</style>


// WEBPACK FOOTER //
// src/components/public/top.vue